<template>
    <div>
        <a v-on:click="show = !show">
          <span class="icon">
            <font-awesome-icon :icon="['fas', 'chevron-right']" v-if="!show"></font-awesome-icon>
            <font-awesome-icon :icon="['fas', 'chevron-down']" v-if="show"></font-awesome-icon>
          </span>
          {{ userName }}
        </a>
        <div class="columns" v-if="show">
          <div class="column is-6">
            <transition name="fade">
              <TimeRegistrations v-if="show && anyNotApproved" :user-id="this.userId"></TimeRegistrations>
              <p class="help" v-if="!anyNotApproved">{{$t("absence.noApp")}}</p>
            </transition>
          </div>
          <div class="column is-6">
            <regChart :regs="regs" />
          </div>
        </div>
    </div>
</template>

<script>
import firebase from '@/firebase'
import moment from 'moment'
import _ from 'lodash'

import TimeRegistrations from '@/components/TimeRegistrations.vue'
import regChart from '@/components/charts/regChart.vue'


export default {
  name: 'TimeApproverTable',
  props: {
    userId: String,
    userName: String,
  },
  components: {
      TimeRegistrations,
      regChart
  },
    data: function() {
    return {
      show: true
    }
  },
  firebase: function() { 
    const tenantid = JSON.parse(localStorage.getItem('profile')).tenantid;
    const userid = JSON.parse(localStorage.getItem('profile')).user_id;
    return {
        regs: {
          source: firebase.database().ref('/organisations/' + tenantid + '/registrations/' + this.userId).orderByChild('date')
          },
    }
  },
  computed: {
    anyNotApproved() {
      if(_.find(this.regs, {'isApproved': false, 'sentForApproval': true})) {
        return true
      } else {
        this.show = false;
        return false
      }
    }
  }
}
</script>
<style scoped>
</style>
